import { Button } from '../components/button'
import { defineComponent, reactive, Teleport } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from './state'
import Section from '../components/section'
import { Dialog } from '../components/dialog'
import { BAI, HMPS, K_SSES, UCLA } from '../config'
import Questions, { Question } from '../components/questions'
import { Spinner } from '../components/spinner'

export default defineComponent({
  name: 'page.stage6',
  setup () {
    const store = useStore()
    const router = useRouter()

    store.initStage(6)

    const HMPSQuestions: Question[] = HMPS.q.map(q => ({
      q,
      a: HMPS.labels.map((label, idx) => ({
        label,
        value: String(idx),
      })),
    }))
    const BAIQuestions: Question[] = BAI.q.map(q => ({
      q,
      a: BAI.labels.map((label, idx) => ({
        label,
        value: String(idx),
      })),
    }))
    const K_SSESQuestions: Question[] = K_SSES.q.map(q => ({
      q,
      a: K_SSES.labels.map((label, idx) => ({
        label,
        value: String(idx),
      })),
    }))
    const UCLAQuestions: Question[] = UCLA.q.map(q => ({
      q,
      a: UCLA.labels.map((label, idx) => ({
        label,
        value: String(idx),
      })),
    }))

    const state = reactive({
      showInvalidPopup: false,
      showSuccessPopup: false,
      loading: false,
    })

    const goToNext = async () => {
      if (store.stageValidity !== true) return

      state.loading = true
      const res = await store.submit2()
      state.loading = false

      if (!res.success) {
        return alert('서버 에러! 관리자에게 문의해주세요')
      }

      if (!store.possibleToSubmit) {
        state.showInvalidPopup = true
      } else {
        router.push({
          name: 'stage7',
        })
      }
    }

    const goToSchemaResult = () => {
      router.push({
        name: 'result',
        query: {
          code: store.schemaResultCode,
        },
      })
    }

    return () => [
      <div class="py-10">
        <Section onlyMobile={false}>
          <div class="text-[#245058] basis-full font-bold text-3xl text-center">
            설문참여를 위해 정보를 입력해주세요
          </div>
        </Section>
        {/* HMPS */}
        <Section onlyMobile={false} class="mt-12">
          <div class="text-xl text-center basis-full">
            <div>HMPS 검사</div>
            <div class="mt-2 text-base">{HMPS.description}</div>
          </div>
        </Section>
        <Section onlyMobile={true}>
          <Questions
            questions={HMPSQuestions}
            values={store.HMPSInputs.map(String)}
            onInput={v => (store.HMPSInputs = v.map(Number))}
          />
        </Section>
        {/* BAI */}
        <Section onlyMobile={false} class="mt-12">
          <div class="text-xl text-center basis-full">
            <div>BAI 검사</div>
            <div class="mt-2 text-base">{BAI.description}</div>
          </div>
        </Section>
        <Section onlyMobile={true}>
          <Questions
            questions={BAIQuestions}
            values={store.BAIInputs.map(String)}
            onInput={v => (store.BAIInputs = v.map(Number))}
          />
        </Section>
        {/* K_SSES */}
        <Section onlyMobile={false} class="mt-12">
          <div class="text-xl text-center basis-full">
            <div>K_SSES 검사</div>
            <div class="mt-2 text-base">{K_SSES.description}</div>
          </div>
        </Section>
        <Section onlyMobile={true}>
          <Questions
            questions={K_SSESQuestions}
            values={store.K_SSESInputs.map(String)}
            onInput={v => (store.K_SSESInputs = v.map(Number))}
          />
        </Section>
        {/* UCLA */}
        <Section onlyMobile={false} class="mt-12">
          <div class="text-xl text-center basis-full">
            <div>UCLA 검사</div>
            <div class="mt-2 text-base">{UCLA.description}</div>
          </div>
        </Section>
        <Section onlyMobile={true}>
          <Questions
            questions={UCLAQuestions}
            values={store.UCLAInputs.map(String)}
            onInput={v => (store.UCLAInputs = v.map(Number))}
          />
        </Section>
        <Section onlyMobile={true}>
          <Button
            class="w-full"
            disabled={!store.stageValidity || state.loading}
            onClick={goToNext}
          >
            <div class="flex justify-center items-center">
              <div class="mr-2">
                <Spinner v-show={state.loading} />
              </div>
              <div>계속</div>
            </div>
          </Button>
        </Section>
      </div>,
      <Teleport to="body">
        <Dialog
          visible={state.showInvalidPopup}
          showCloseButton={true}
          closeOnBackdrop={true}
          onClose={goToSchemaResult}
        >
          <div class="p-8 text-center basis-full">
            아쉽지만 귀하는 연구 참여 대상에 해당되지 않습니다. 연구에 관심을
            가져주셔서 감사합니다.
          </div>
        </Dialog>
      </Teleport>,
    ]
  },
})
